import { IdName } from './idname';
import { Totaling } from './totaling';
import { FormulaElement } from './formulaElement';

export class ReportDefinitionLine {
    Id;
    LineNo: number = 0;
    RowNo;
    Description;
    TotalingType: any;
    RowType: any;
    ReportLineFormat: any;
    ParentLine: any;
    Totaling: Totaling[];
    Formula: IdName;
    A: FormulaElement[];
    ARep: IdName;
    B: FormulaElement[];
    BRep: IdName;
    C: FormulaElement[];
    CRep: IdName;
    D: FormulaElement[];
    DRep: IdName;
    ShowValues;
    ShowOppositeSign;
    AccountType: any;
    DimensionsTotaling1: Totaling[];
    DimensionsTotaling2: Totaling[];
    DimensionsTotaling3: Totaling[];
    DimensionsTotaling4: Totaling[];
    Filter: string[];
    ReportId : number;
    Constant: any;
}
